import { IStudyChild } from '../entity';
import { schema } from 'normalizr';
import {
  AnnotationSessionSummaryDto,
  SessionStatus,
} from '@core/services/api-client.generated';
import {
  AnnotationEntityKeys,
  annotationSchema,
} from '@core/state/entities/annotation/annotation.entity';
import {
  OutcomeDataEntityKeys,
  outcomeDataSchema,
} from '@core/state/entities/outcome-data/outcome-data.entity';
import {
  AnnotationsKey,
  OutcomeDataKey,
  SessionsKey,
} from '@core/state/entities/entity-name-map';

export interface ISession
  extends Omit<AnnotationSessionSummaryDto, 'entityOrder'>, IStudyChild {
  /** Legacy sessions and clients may omit this additive review metadata. */
  entityOrder?: string[] | null;
}

export type SessionEntityKeys =
  | SessionsKey
  | AnnotationEntityKeys
  | OutcomeDataEntityKeys;
export const sessionSchema = new schema.Entity<ISession>('sessions', {
  annotations: [annotationSchema],
  outcomeData: [outcomeDataSchema],
});
